

















































import { Component, Vue, Provide } from 'vue-property-decorator';
import {
  Action, Mutation, State, Getter, namespace,
} from 'vuex-class';
import NProgress from 'nprogress';
import MyNav from '@/components/skeleton/top.vue'; // 骨架结构顶部
import {
  Button, DatePicker, Form, FormItem, Input, Message, Option, Radio, Scrollbar, Select,
} from 'element-ui';
import fa from 'element-ui/src/locale/lang/fa';
import Sign from '../../servers/modules/signinsignup';

    @Component({
      components: {
        MyNav,
        Button,
        Scrollbar,
        Form,
        FormItem,
        Input,
        Select,
        Option,
        DatePicker,
        Radio,
      },
    })
export default class extends Vue {
        private registerData: any = {
          gradeId: '',
          password: '',
          productId: '',
        };

        private courseList: any = [];

        private step: number = 0;

        private loading: boolean = false;

        // next
        private next() {
          this.getCoursePasswordToObtainCourseRelatedData().then((res: any) => {
            if (!res.data.code) {
              this.loading = false;
              this.courseList = res.data.data;
              this.step = 2;
            }
          }).catch((err: any) => {
          }).finally((e) => {
            this.loading = false;
          });
        }

        // 课程密码获取课程相关数据
        private async getCoursePasswordToObtainCourseRelatedData() {
          return await Sign.getObtainCourseRelatedDataByCoursePassword({ password: this.registerData.password });
        }

        private async openCourse() {
          if (!this.registerData.productId) {
            Message.warning('请选定课程');
            return false;
          }
          if (!this.registerData.gradeId) {
            Message.warning('请选择优先学习课程');
            return false;
          }
          await Sign.bindProduct(this.registerData).then((res) => {
            if (res && !res.data.code) {
              Message.success('开通课程成功');
              this.step = 0;
            }
          }).catch((e) => {

          });
        }

        private get productName() {
          const value = this.courseList.filter((item: any) => item.productId == this.registerData.productId);
          if (value && value[0] && value[0].productNameAll) {
            const result = value[0].productNameAll;
            return result;
          }
          return '';
        }

        private get gradeName() {
          const value = this.courseList.filter((item: any) => item.productId == this.registerData.productId);
          if (value && value[0] && value[0].productDetailVos) {
            const result = value[0].productDetailVos.filter((item: any) => item.gradeId == this.registerData.gradeId);
            if (result && result[0] && result[0].gradeName) {
              const name = result[0].gradeName;
              return name;
            }
          } else {
            return '';
          }
        }

        // 优先选择
        private get priorList() {
          const value = this.courseList.filter((item: any) => item.productId == this.registerData.productId);
          if (value && value[0] && value[0].productDetailVos) {
            const result = value[0].productDetailVos;
            return result;
          }
          return '';
        }
}
